import React from 'react';

import { TextField, Typography } from '@mui/material';
import { validateHeight, validateWidth } from '../admin-utils';

interface IframeEditorProps {
  iframeUrl?: string;
  iframeHeight?: string | number; // Updated to accept number as well
  iframeWidth?: string | number;
  onPropChange: (key: string, value: any) => void;
}

const IframeEditor: React.FC<IframeEditorProps> = ({
  iframeUrl,
  iframeHeight,
  iframeWidth,
  onPropChange,
}) => {
  return (
    <>
      <Typography variant="h6">Content Options</Typography>
      <TextField
        label="Iframe URL"
        value={iframeUrl || ''}
        onChange={(e) => onPropChange('iframeUrl', e.target.value)}
        placeholder="Enter URL to embed (e.g. https://www.youtube.com/embed/VIDEO_ID)"
        fullWidth
        margin="normal"
        error={Boolean(iframeUrl) && !iframeUrl?.match(/^https?:\/\/.+/)}
        helperText={
          iframeUrl && !iframeUrl.match(/^https?:\/\/.+/)
            ? 'URL must start with http:// or https://'
            : ''
        }
      />
      <TextField
        label="Iframe Height"
        value={iframeHeight || ''}
        onChange={(e) => onPropChange('iframeHeight', e.target.value)}
        onBlur={(e) => {
          const value = validateHeight(e.target.value);
          onPropChange('iframeHeight', value);
        }}
        placeholder="Enter height (e.g. 500px, 50vh)"
        fullWidth
        margin="normal"
      />
      <TextField
        label="Iframe Width"
        value={iframeWidth || ''}
        onChange={(e) => onPropChange('iframeWidth', e.target.value)}
        onBlur={(e) => {
          const value = validateWidth(e.target.value);
          onPropChange('iframeWidth', value);
        }}
        placeholder="Enter width (e.g. 800px, 100%, 80vw)"
        fullWidth
        margin="normal"
      />
    </>
  );
};

export default IframeEditor;
